module.exports = __webpack_public_path__ + "media/images/lp_v6_step01-36e70764185b729b634c9a3f38e1f92b.webp";